/**
 * This is a helper function to provide Tailwind intellisense for classes outside of the `className` attribute.
 *
 * @example
 * const classes = tw`bg-blue-500 text-white p-4`;
 */
export const tw = (classes: TemplateStringsArray | string, ...args: string[]): string => {
  if (typeof classes === 'string') {
    return classes;
  }

  return classes.reduce((acc, part, index) => {
    return acc + part + (args[index] || '');
  }, '');
};
